export default __webpack_public_path__ + "static/media/logo.a241d42b.png";